import { patchConsoleError } from './intercept-console-error'

patchConsoleError()
